import { CompoundSettingsComponent } from './compound-settings.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const compoundSettingsRoutes: Routes = [
  {
    path: 'admin/compound-settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_SETTINGS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: CompoundSettingsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
